import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast.component';
import { ToastService } from './toast.service';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule
  ],
  declarations: [
    ToastComponent
  ],
  providers: [
    ToastService
  ],
  entryComponents: [
    ToastComponent
  ],
})
export class ToastModule {}
